import { createReducer, on } from '@ngrx/store';
import { ResetStateFromRouter } from 'src/app/shared/actions/eliqua.actions';
import { EditCampaignSuccess } from '../actions/campaign-search.actions';
import {
  CampaignCountryChanged,
  CampaignSchemaChanged,
  CampaignSelectionTargetChanged,
  ClickedNext,
  HideCountryError,
  HideSchemaError,
  ShowCountryError,
  ShowSchemaError,
  ToggleHelpTextStatus,
} from '../actions/wizard-setup.actions';
import { ResetWizard } from '../actions/wizard.actions';
import { WizardSetupState } from '../models/wizard.model';

const initialState: WizardSetupState = {
  campaignSelectionTarget: '',
  campaignSchema: '',
  campaignCountry: '',
  campaignSelectionTargetErrorMessage: '',
  showCampaignSelectionTargetErrorMessage: false,
  countries: [],
  schemas: [],
  countryErrorMessage: '',
  schemaErrorMessage: '',
  showCountryErrorMessage: false,
  showSchemaErrorMessage: false,
  helpTextStatus: false,
  hasClickedNext: false,
};

export const WizardSetupReducer = createReducer(
  initialState,
  on(EditCampaignSuccess, (state, { campaign }) => ({
    ...state,
    campaignSelectionTarget: campaign.data.campaignSelectionTarget,
    campaignSchema: campaign.data.loyaltySchemaId,
    campaignCountry: campaign.data.memberRegistrationCountryId,
  })),
  on(ToggleHelpTextStatus, (state) => ({
    ...state,
    helpTextStatus: !state.helpTextStatus,
  })),
  on(CampaignSchemaChanged, (state, { campaignSchema }) => ({
    ...state,
    campaignSchema,
  })),
  on(CampaignCountryChanged, (state, { campaignCountry }) => ({
    ...state,
    campaignCountry,
  })),
  on(CampaignSelectionTargetChanged, (state, { campaignSelectionTarget }) => {
    return campaignSelectionTarget === 'LOYALTYMEMBER'
      ? {
          ...state,
          campaignSelectionTarget,
          hasClickedNext: false,
        }
      : {
          ...state,
          campaignSelectionTarget,
          campaignSchema: '',
          campaignCountry: '',
          hasClickedNext: false,
        };
  }),
  on(ShowSchemaError, (state) => ({
    ...state,
    showSchemaErrorMessage: true,
  })),
  on(ShowCountryError, (state) => ({
    ...state,
    showCountryErrorMessage: true,
  })),
  on(HideCountryError, (state) => ({
    ...state,
    showSchemaErrorMessage: false,
  })),
  on(HideSchemaError, (state) => ({
    ...state,
    showCountryErrorMessage: false,
  })),
  on(ClickedNext, (state, { clickedNext }) => ({
    ...state,
    hasClickedNext: clickedNext,
  })),
  on(ResetWizard, () => ({
    ...initialState,
  })),
  on(ResetStateFromRouter, () => ({
    ...initialState
  }))
);
